import { Link } from "react-router-dom";
import { PatchCheckFill } from "react-bootstrap-icons";
import { ASSETS, HERO_ACTIONS } from "./data/landingData";

const LandingHero = () => (
  <section className="lp-hero" style={{ "--lp-hero-image": `url(${ASSETS.heroBackground})` }} aria-labelledby="lp-hero-title">
    <div className="container">
      <div className="lp-hero__content text-center mx-auto">
        <span className="lp-badge lp-badge--glass">
          <PatchCheckFill aria-hidden="true" /> India&apos;s Trusted Real Estate &amp; Home Ecosystem
        </span>
        <h1 id="lp-hero-title" className="lp-hero__title">
          Find Your <span className="lp-hero__accent">Dream Property</span>
        </h1>
        <p className="lp-hero__sub">
          Explore verified homes, villas and commercial spaces across India&apos;s top cities, with expert
          guidance from search to keys.
        </p>
        <div className="d-flex flex-wrap justify-content-center gap-3">
          {HERO_ACTIONS.map(({ to, label, variant }) => (
            <Link key={label} to={to} className={`lp-btn lp-btn--lg lp-btn--${variant}`}>
              {label}
            </Link>
          ))}
        </div>
      </div>

    </div>
  </section>
);

export default LandingHero;
